import { render } from "./CrudLicencaOrgaoErroDetalhes.vue?vue&type=template&id=733374fe"
import script from "./CrudLicencaOrgaoErroDetalhes.vue?vue&type=script&lang=ts"
export * from "./CrudLicencaOrgaoErroDetalhes.vue?vue&type=script&lang=ts"
script.render = render

export default script